export type ToastSeverity = "info" | "warning" | "error";

/** Optional inline call-to-action attached to a toast. */
export interface ToastAction {
  /** Short verb-led label, e.g. "Open Settings", "Undo". */
  label: string;
  /** Click handler. The toast auto-dismisses after this fires. */
  onClick: () => void;
}

export interface ToastEntry {
  id: number;
  message: string;
  severity: ToastSeverity;
  duration: number;
  dedupKey?: string;
  action?: ToastAction;
}

export interface ToastOptions {
  severity?: ToastSeverity;
  duration?: number;
  dedupKey?: string;
  action?: ToastAction;
}

type ToastSink = (entry: ToastEntry) => void;

let nextId = 0;
let addToast: ToastSink | null = null;

/** Show a toast notification. */
export function showToast(message: string, options?: ToastOptions): void {
  const entry: ToastEntry = {
    id: nextId++,
    message,
    severity: options?.severity ?? "info",
    duration: options?.duration ?? 4000,
    dedupKey: options?.dedupKey,
    action: options?.action,
  };
  addToast?.(entry);
}

export function registerToastSink(sink: ToastSink): () => void {
  addToast = sink;
  return () => {
    if (addToast === sink) {
      addToast = null;
    }
  };
}
